import { render, staticRenderFns } from "./CheckoutSession.vue?vue&type=template&id=1313bf13&scoped=true&"
import script from "./CheckoutSession.vue?vue&type=script&lang=js&"
export * from "./CheckoutSession.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutSession.vue?vue&type=style&index=0&id=1313bf13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1313bf13",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VRow})
